export enum LocaleCodes {
  EN_GB = "en-GB",
  PT_PT = "pt-PT",
}
